import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('group',
  '/plans/group',
  'group')
const reducer = generator.generate()

export default reducer

